import type { FetchResult } from "./opsPaperworkClientBase";
import { opsFetch, q } from "./opsPaperworkClientBase";
import type { GoogleCalendarLinkStatus } from "./messages/googleCalendarInboundModel";

export type GoogleCalendarUpcomingEvent = {
  notification_id: string;
  google_event_id: string;
  title: string;
  html_link: string | null;
  start_label: string;
  read_at: string | null;
};

export type GoogleCalendarStatusResponse = GoogleCalendarLinkStatus & {
  ok: true;
  oauth_configured: boolean;
};

export type GoogleCalendarUpcomingResponse = {
  ok: true;
  linked: boolean;
  events_today_count: number;
  events: GoogleCalendarUpcomingEvent[];
};

export async function getGoogleCalendarStatus(): Promise<FetchResult<GoogleCalendarStatusResponse>> {
  return opsFetch(q("google-calendar-status"), { method: "GET" });
}

export async function getGoogleCalendarOAuthStart(): Promise<
  FetchResult<{ ok: true; authorize_url: string; redirect_uri: string }>
> {
  return opsFetch(q("google-calendar-oauth-start"), { method: "GET" });
}

export async function postGoogleCalendarDisconnect(): Promise<FetchResult<{ ok: true; linked: false }>> {
  return opsFetch(q("google-calendar-disconnect"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: "{}",
  });
}

export async function postGoogleCalendarSync(body?: { force?: boolean }): Promise<
  FetchResult<{
    ok: true;
    synced_at: string;
    inserted: number;
    updated: number;
    skipped_origin: number;
    events_today: number;
  }>
> {
  return opsFetch(q("google-calendar-sync"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body ?? {}),
  });
}

export async function getGoogleCalendarUpcoming(): Promise<FetchResult<GoogleCalendarUpcomingResponse>> {
  return opsFetch(q("google-calendar-upcoming"), { method: "GET" });
}
